import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource } from '@angular/material/tree';
import { FullscreenLayoutTemplate } from '@src/assets/css/fullscreen.template.scss';
import { ViewStateRecord } from '@src/suite/common/data-models/records/viewstate-record';
import { TreeLikeFlatNode, TreeLikeNode } from '@src/suite/common/data-models/search-results/search-results';
import { SearchType } from '@src/suite/common/enums/enums';

export enum SidecarMenu {
    TOPICS = 'topics',
    ASSIGNMENTS = 'assignments',
    MOS = 'mos',
    AP_AI_SEARCH = 'ap-ai-search',
    RUNDOWNS = 'rundowns',
    STORYPROPERTIES = 'storyproperties',
    STORIES = 'stories',
}

export type SidecarState = {
    selected: SidecarMenu;
    assignmentListGuids?: string[];
    selectedAssignmentGuid?: string;
    storedAssignmentViewStates?: Array<ViewStateRecord> | null;
    currentAssignmentViewStateGuid?: string | null;
    selectedAssignmentListSearchType?: SearchType;
    storyListGuids?: string[];
    selectedStoryGuid?: string;
    selectedStoryHasUnsavedChanges: boolean;
    storedStoryViewStates?: Array<ViewStateRecord> | null;
    currentStoryViewStateGuid?: string | null;
    selectedStoryListSearchType?: SearchType;
    topicListGuids?: string[];
    storedTopicViewStates?: Array<ViewStateRecord> | null;
    currentTopicViewStateGuid?: string | null;
    selectedTopicListSearchType?: SearchType;
    rundownListGuids?: string[];
    storedRundownViewStates?: Array<ViewStateRecord> | null;
    currentRundownViewStateGuid?: string | null;
    selectedRundownGuid?: string | null;
    currentRundownSelectedStoryGuid?: string | null;
    selectedRundownListSearchType?: SearchType;
    selectedTopicGuid?: string | null;
    currentTopicSelectedStoryGuid?: string | null;
    currentTopicSelectedAssignmentGuid?: string | null;
    selectedMosItemID?: string | null;
};

export type FullscreenState = {
    template: FullscreenLayoutTemplate;
    recordGuid: string;
    recordType: number;
    recordHasUnsavedChanges: boolean;
    currentViewRecordGuid: string;
    standaloneStory: boolean;
    pinnedItemGuids: string[];
    selectedPinnedItemGuid: string;
    searchTerm: string;
    searchResultGuids: string[];
    showLoader: boolean;
    treeDataPair?: {
        treeDataSource: MatTreeFlatDataSource<TreeLikeNode<StorytellingRecord>, TreeLikeFlatNode<StorytellingRecord>, string>;
        treeControl: FlatTreeControl<TreeLikeFlatNode<StorytellingRecord>, string>;
    };
};

export type FullscreenNewRecordState = {
    record: StorytellingRecord;
    recordTemplateGuid: string;
    selectedStoryIndex: number;
    createInGroupData: any;
    recordCreating: boolean;
    wireRecord?: StorytellingWireRecord;
};

export const BASE_TEMPLATE_CLASS = 'st-full-screen-dialog__content';

export enum CloseModalAction {
    CLOSE_MODAL = 'Close modal',
}
